










































































import { ref, defineComponent, PropType, useContext } from '@nuxtjs/composition-api';
import {
  SfSelect,
  SfButton,
  SfIcon,
} from '@storefront-ui/vue';
import SvgImage from '~/components/General/SvgImage.vue';
import { useUiHelpers, useUiState } from '~/composables';
import { Pagination } from '~/composables/types';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';

export default defineComponent({
  components: {
    SkeletonLoader,
    SvgImage,
    SfSelect,
    SfButton,
    SfIcon
  },
  props: {
    sortBy: {
      type: Object as PropType<SortingModel>,
      required: true,
    },
    pagination: {
      type: Object as PropType<Pagination>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    activeCategoryName: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const {
      toggleFilterSidebar, changeToCategoryListView, changeToCategoryGridView, isCategoryGridView,
    } = useUiState();
    const uiHelpers = useUiHelpers();
    const { app } = useContext();

    const selectedSort = ref('relevance_DESC');
    const doChangeSorting = (sort: string) => {
      uiHelpers.changeSorting(sort, false);
      emit('reloadProducts');
      selectedSort.value = sort;
    };

    /**
     * to get category products listng page numbers.
     * 
     * @param pagination
     */
     const getProductPaginationDetails = (pagination: Pagination): string => {
      let currentPage: number = Number(pagination.currentPage);
      let itemsPerPage: number = Number(pagination.itemsPerPage);
      let totalItems: number = Number(pagination.totalItems);
      let startsFrom: number = ((currentPage - 1) * itemsPerPage) + 1;
      let endsHere: number = (currentPage * itemsPerPage < totalItems) ? currentPage * itemsPerPage : totalItems;
      return `${app.i18n.t('Showing')} ${startsFrom} - ${endsHere} ${app.i18n.t('of')} ${totalItems} ${app.i18n.t('products')}`;
    };

    return {
      toggleFilterSidebar,
      doChangeSorting,
      ...uiHelpers,
      changeToCategoryListView,
      changeToCategoryGridView,
      isCategoryGridView,
      getProductPaginationDetails,
      selectedSort
    };
  },
});
